import React from "react";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { LoadingButton } from "@rentablo/components";
import { useDeleteBankConnectionsCashbackV2 } from "@rentablo/api/apiv1";
import { SendEventType } from "../stateMachine/typings/SendEventType";

const LoadingButtonWithSpacer = styled(LoadingButton)`
  margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

export interface Props {
  sendEvent: SendEventType;
}

export const DeleteAccounts = ({ sendEvent }: Props) => {
  const { t } = useTranslation();

  const { mutateAsync, isPending } = useDeleteBankConnectionsCashbackV2({
    throwOnError: true,
  });
  const handleDelete = async () => {
    await mutateAsync();
    sendEvent({ type: "DEACTIVATE" });
  };

  return (
    <>
      <Typography variant="h4" component="h1" mb={6}>
        {t("netfondsConsent.deleteAccounts.heading")}
      </Typography>
      <Typography variant="body1" mb={8}>
        {t("netfondsConsent.deleteAccounts.teaser")}
      </Typography>

      <div>
        <LoadingButtonWithSpacer
          isFetching={isPending}
          variant="primary"
          onClick={() => handleDelete()}
        >
          {t("netfondsConsent.deleteAccounts.delete")}
        </LoadingButtonWithSpacer>
      </div>

      <Button
        disabled={isPending}
        variant="tertiary"
        onClick={() => sendEvent({ type: "DEACTIVATE" })}
      >
        {t("netfondsConsent.deleteAccounts.keep")}
      </Button>
    </>
  );
};
